<script setup >
import { ref, onMounted, onBeforeUnmount } from 'vue'
import TttfBirthday from "@/components/TttfBirthday.vue";
import CorridorTime from "./CorridorTime.vue";
import daergou2 from "@/assets/daergou_caihong.jpg";
import MakeWish from "@/components/MakeWish.vue";
import xiangshi from "@/assets/xiangshi.jpg"
import lvyou from "@/assets/lvyou.jpg"
import dinghun from "@/assets/dinghun.jpg"
import dangao from "@/assets/dangao.png"


const index = ref(0)

// 音乐播放逻辑移到父组件，确保组件切换时音乐继续播放
const bgmUrl = new URL('../assets/music.m4a', import.meta.url).href
const bgmAudio = ref()
const isPlaying = ref(false)
const mills = ref(0)

const toggleMusic = () => {
  const audio = bgmAudio.value
  const mills_new = new Date().getTime()
  console.log('result',mills_new - mills.value)
  if (mills_new - mills.value < 1000) return
  mills.value = mills_new
  if (!audio) return
  if (isPlaying.value) {
    audio.pause()
  } else {
    try {
      audio.play()
    } catch (err) {
      console.warn('Audio play failed:', err)
    }
  }
}

// 保持 isPlaying 与实际音频元素状态同步

const timeline =ref([
  {
    img: xiangshi,
    date: "2025年01月",
    text: "相识"
  },
  {
    img: lvyou,
    date: "2025年04月",
    text: "一起去旅游"
  },
  {
    img: dinghun,
    date: "2025年10月",
    text: "我们订婚啦"
  },
  {
    img: dangao,
    date: "2026年01月10日",
    text: "宝宝生日快乐"
  },
  {
    img: daergou2,
    date: "未完待续...",
    text: "美好的事情正在发生..."
  }
])

onMounted(() => {
  const audio = bgmAudio.value
  if (!audio) return
  const handlePlay = () => { isPlaying.value = true }
  const handlePause = () => { isPlaying.value = false }
  audio.addEventListener('play', handlePlay)
  audio.addEventListener('pause', handlePause)
  audio.addEventListener('ended', handlePause)
  onBeforeUnmount(() => {
    audio.removeEventListener('play', handlePlay)
    audio.removeEventListener('pause', handlePause)
    audio.removeEventListener('ended', handlePause)
  })
})
</script>

<template>
<TttfBirthday v-if="index === 0" @next-chapter="index = 1" :isPlaying="isPlaying" :toggleMusic="toggleMusic" />
<CorridorTime v-if="index === 1" @next-chapter="console.log(222),index = 2" :isPlaying="isPlaying" :toggleMusic="toggleMusic" :timeline="timeline" />
<MakeWish v-if="index === 2" :isPlaying="isPlaying" :toggleMusic="toggleMusic" :timeline="timeline" />

<!-- 全局音乐控制 -->
<div @click="toggleMusic" :class="['music-btn', { playing: isPlaying }]">
  <span>🎵</span>
</div>
<audio ref="bgmAudio" loop :src="bgmUrl"></audio>
</template>

<style scoped>
.music-btn {
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 1000;
  width: 44px;
  height: 44px;
  background: rgba(255,255,255,0.85);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0,0,0,0.12);
  animation: spin 4s linear infinite;
  animation-play-state: paused;
  font-size: 18px;
}
/* when playing, enable rotation */
.music-btn.playing {
  animation-play-state: running;
}
@keyframes spin { 100% { transform: rotate(360deg); } }
</style>
